module.exports = __webpack_public_path__ + "img/index-teacher@2x.dc5eb75e.png";